
import { httpDelete, httpGet, httpPost } from "./api/axios_api";
import Constants from "../constants/constants";

const actions = {
    getTournamentList: "GET_TROUNAMENT_LIST",
    deleteTournament: "DELETE_TOURNAMENT"
}

export async function getTournamentLeaderboardEntries(tournamentID, leaderboardType, page, daily, token) {
    let url = `${Constants.BACKEND_URL}/get-leaderboard-entries/${tournamentID}/${leaderboardType}/${page}/${daily}`;
    return httpGet(url, {}, token);
}

export async function getActiveTournament(token) {
    let url = `${Constants.BACKEND_URL}/get-active-tournament`;
    return httpGet(url, {}, token);
}

export function upsertTournament(token, tournament) {
    let url = `${Constants.BACKEND_URL}/tournaments/`;
    return httpPost(url, tournament, token);
}

export function getTournamentDates(token, value) {
    const url = `${Constants.BACKEND_URL}/tournaments/dates/`;
    return httpGet(url, { params: { "business_group_id": value } }, token);
}

export async function deleteTournament(token, tournamentId) {
    const url = `${Constants.BACKEND_URL}/tournaments/${tournamentId}`;
    return httpDelete(url, {}, token)
}

export function getTotalNumOfTournaments(token, searchString) {
    const url = `${Constants.BACKEND_URL}/tournaments/getTotalNumOfTournaments/`;
    return httpGet(url, { params: { searchParams: searchString } }, token);
}

export function getTournamentList(token, offset, limit, searchString) {
    // this is going to return a function 
    return dispatch => {
        //console.log("   ~~~ getTournamentList")
        const url = `${Constants.BACKEND_URL}/tournaments/`

        return httpGet(url, { params: { offset, limit, searchParams: searchString } }, token)
            // then is a promise !! 
            .then((response) => {
                //console.log("   ~~~ getTournamentList: RESPONSE")
                //console.log(response)
                if (typeof response !== "undefined" && response.data.success) {
                    const transmit_this = {
                        type: actions.getTournamentList,
                        data: {
                            tournaments: response.data.tournaments,
                            totalNumOfTournaments: response.data.totalNumOfTournaments,
                            offset,
                            limit,
                            searchString
                        }
                    }
                    //console.log(transmit_this)
                    dispatch(transmit_this)
                }
            });
    }
}

const INITIAL_STATE = {
    tournaments: [],
    offset: 0,
    limit: 10,
}

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.getTournamentList:
            console.log("   ~~~ tournament reducer")
            console.log(action)
            return {
                ...state,
                ...action.data
            }
        default:
            return { ...state };
    }
}


// WEBPACK FOOTER //
// ./src/modules/tournament.js